import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { TranslationService } from 'core/translation/translation.service';
import { DialogComponent } from '../dialog.component';

@Component({
    selector: 'error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrls: ['../dialog.scss'],
    standalone: false
})
export class ErrorDialogComponent extends DialogComponent implements OnInit
{
  public errors: { [title: string]: Array<Error>};
  public Object: any = Object;

  constructor(
      @Inject(MAT_DIALOG_DATA) protected dialogData: any,
      @Inject(TranslationService) private translationService
  )
  {
    super(dialogData);
  }

  public trackByTitle(index: number, error: any): string
  {
    return error.title;
  }

  public ngOnInit(): void
  {
    this.errors = {};

    for (let error of this.dialogData.errors) {
      const languageKey = this.translationService.getLanguageKeyPrefix(
          'error', error.name);

      error.title =
          this.translationService.get(languageKey + '.title') || error.name;
      error.text = this.translationService.translateErrorMessage(
          languageKey, error.reference) || error.message;

      const title = error.title;

      if (!this.errors.hasOwnProperty(title)) {
        this.errors[title] = [];
      }
      this.errors[title].push(error);
    }
  }
}
